import { ReactNode } from "react";
import { Keyboard } from "react-native";
import { TouchableWithoutFeedback } from "react-native-gesture-handler";
import useDevice from "src/hooks/useDevice";
import { SafeArea } from "src/swsh-native";
import { SafeAreaProps } from "src/swsh-native/SafeArea/types";
import Header, { HeaderProps } from "../Header";

const HeaderContainer = ({
	children,
	headerText,
	safeAreaProps,
	keyboardDismiss,
	...headerProps
}: {
	children: ReactNode;
	headerText?: string;
	safeAreaProps?: Omit<SafeAreaProps, "children">;
	keyboardDismiss?: boolean;
} & Omit<HeaderProps, "children" | "hasSafeArea">) => {
	const { native } = useDevice();
	const Content = (
		<SafeArea {...safeAreaProps}>
			<Header {...headerProps}>{headerText}</Header>
			{children}
		</SafeArea>
	);
	return keyboardDismiss && native ? (
		<TouchableWithoutFeedback
			accessible={false}
			onPress={Keyboard.dismiss}
			containerStyle={{
				flex: 1,
			}}
			style={{
				flex: 1,
			}}
		>
			{Content}
		</TouchableWithoutFeedback>
	) : (
		Content
	);
};

export default HeaderContainer;
